export default __webpack_public_path__ + "static/media/step3.42da198c.svg";